var map = {
	"./Logo.png": 217,
	"./Navbar Logo.png": 909,
	"./bg.jpg": 645,
	"./datamantis.png": 572,
	"./exgen.png": 609,
	"./mozilor.png": 440,
	"./securetraces.png": 749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;